import { Controller } from 'react-hook-form'

import { TCommonFields } from '../../types'
import { FieldRow, getFieldRules } from '../field-row'
import { useFieldState } from '../hooks'

export type TCheckboxField<T> = TCommonFields<T> & {
    type: 'checkbox'
    default?: boolean
    /** receives the raw value from `data` (e.g. MySQL 0/1) */
    formatDefault?: (data: any) => boolean
}

type TProps<T> = {
    rowField: TCheckboxField<T>
    fieldName?: string
    labelWidth?: string
}

const CheckboxField = <T,>({ rowField, fieldName, labelWidth }: TProps<T>) => {
    const { disabled, required } = useFieldState(rowField)
    const fieldName_ = fieldName ?? rowField.name

    return (
        <FieldRow
            fieldName={fieldName_}
            label={rowField.label}
            required={required}
            labelWidth={labelWidth}
            className="form-checkbox"
        >
            <Controller
                name={fieldName_}
                rules={getFieldRules(rowField, required)}
                render={({ field }) => (
                    <input
                        {...field}
                        id={fieldName_}
                        type="checkbox"
                        required={required}
                        disabled={disabled}
                        checked={!!field.value}
                        onChange={e => {
                            field.onChange(e)
                            rowField.onChange?.(e.target.checked)
                        }}
                    />
                )}
            />
        </FieldRow>
    )
}

export default CheckboxField
